import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown } from 'react-feather';
import styled from 'styled-components';
import { style, useAuthentication } from '../../api';
import { CommunityPostInfo } from '../../api/lib/api/musicKnowledgeHub';
import AuthenticationPopupDialog from '../Modals/AuthenticationPopupDialog';

const UpvoteDownVote = styled(
  ({
    type,
    onClick,
    className,
    voteData,
  }: {
    onClick: () => void;
    className?: string;
    voteData: CommunityPostInfo;
    type: 'upvote' | 'downvote';
  }) => {
    const [
      isAuthenticationDialogOpen,
      setIsAuthenticationDialogOpen,
    ] = useState(false);
    const { isLoggedIn } = useAuthentication();
    const getIsVote = (voteInfo: number | null, typeVote: string) => {
      if (typeVote === 'upvote') {
        if (voteInfo === 1) {
          return true;
        }
        return false;
      }
      if (typeVote === 'downvote') {
        if (voteInfo === -1) {
          return true;
        }
        return false;
      }
      return false;
    };

    const onClickForVote = () => {
      if (isLoggedIn) {
        onClick();
      } else {
        handleAuthenticationDialogOpen();
      }
    };
    const handleAuthenticationDialogClose = () => {
      setIsAuthenticationDialogOpen(false);
    };
    const handleAuthenticationDialogOpen = () => {
      setIsAuthenticationDialogOpen(true);
    };

    return (
      <>
        <VotesWrapper className={className}>
          {type === 'upvote' ? (
            <>
              {getIsVote(voteData.logged_in_user_voted, type) ? (
                <ThumbsUp
                  className="cursor-pointer"
                  onClick={onClickForVote}
                  size={20}
                  opacity={0.8}
                  fill={style.primary_pink_new}
                  color={style.primary_pink_new}
                />
              ) : (
                <ThumbsUp
                  className="cursor-pointer"
                  size={20}
                  onClick={onClickForVote}
                />
              )}
            </>
          ) : (
            <>
              {getIsVote(voteData.logged_in_user_voted, type) ? (
                <ThumbsDown
                  className="cursor-pointer"
                  size={20}
                  fill={style.black}
                  opacity={0.8}
                  color={style.black}
                  onClick={onClickForVote}
                />
              ) : (
                <ThumbsDown
                  className="cursor-pointer"
                  size={20}
                  onClick={onClickForVote}
                />
              )}
            </>
          )}
        </VotesWrapper>
        <AuthenticationPopupDialog
          isOpen={isAuthenticationDialogOpen}
          onClose={handleAuthenticationDialogClose}
        />
      </>
    );
  },
)``;

const VotesWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-left: 10px;
  }
  .margin-upvote {
    margin-right: 0.2rem;
  }
`;

export default UpvoteDownVote;
